import {
    EzBadParamException
} from '/ezlibrary/exceptions/EzBadParamException.js';

import { EzEnumeration2 } from '/ezlibrary/enums/EzEnumeration2.js';

import {
    EzObject,
    EzFunction
} from '/ezlibrary/helpers/EzHelpers.js';


/**
 * EzClockerFeature enumeration
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into non-enumeration classes with:
 *      import {
 *          EzClockerFeature
 *      } from '/ezlibrary/enums/EzEnumerations.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Import into other enumeration classes with:
 *      import { EzClockerFeature } from '/ezlibrary/EzClockerFeature.js';
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
export class EzClockerFeature extends EzEnumeration2 {
    /**
     * @static
     * @public @method
     * Iterates each property in the enumeration and calls the
     * provided callbackFunction passing the enumeration value.
     * @param {Function} callbackFunction
     */
    static forEachEnumValue(callbackFunction) {
        if (!EzFunction.isFunction(callbackFunction)) {
            throw new EzBadParamException(
                'callbackFunction',
                EzClockerFeature.ezInstance,
                EzClockerFeature.forEachFeature);
    }

        for (const feature in EzClockerFeature) {
            if (EzObject.isValid(EzClockerFeature?.[feature])) {
                callbackFunction(EzClockerFeature[feature]);
    }
    }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Class Initialization and EzApi Registration Section
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond this section !!
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    /**
     * @private @field
     * Stores the singleton instance of this enumeration class.
     * @type {EzClockerFeature}
     */
    static #ezClockerFeatureSingleton = null;

    /**
     * @static
     * @private @method
     * Builds the enumeration properties and values for EzClockerAccountType
     */
    static #ezBuildEnumeration() {
        this.#ezClockerFeatureSingleton.ezBuildEnumProp(
            // Enumeration Property Name
            'UNKNOWN',
            // Enumeration Property Value
            'UNKNOWN',
            // Optional Enumeration Data Value
            {
                value: 'UNKNOWN',
                display: 'UNKNOWN'
            });

        this.#ezClockerFeatureSingleton.ezBuildEnumProp(
            'JOBS',
            'JOBS',
            {
                value: 'JOBS',
                display: 'Job Features'
            });

        this.#ezClockerFeatureSingleton.ezBuildEnumProp(
            'OVERTIME',
            'OVERTIME',
            {
                value: 'OVERTIME',
                display: 'Overtime Features'
            });
        this.#ezClockerFeatureSingleton.ezBuildEnumProp(
            'INTEGRATIONS',
            'INTEGRATIONS',
            {
                value: 'INTEGRATIONS',
                display: 'Integration Features'
            });

        this.#ezClockerFeatureSingleton.ezBuildEnumProp(
            'TEAM_CHAT',
            'TEAM_CHAT',
            {
                value: 'TEAM_CHAT',
                display: 'Team Chat Features'
            });
    }

    /**
     * @static @initialization
     * Static Initialization of EzClockerFeature
     */
    static {
        if (null == EzClockerFeature.#ezClockerFeatureSingleton) {
            EzClockerFeature.#ezClockerFeatureSingleton = new EzClockerFeature();

            EzClockerFeature.#ezBuildEnumeration();
        }
    }

    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // !! DO NOT PLACE ANY non-initialization fields, getter/setter methods, static methods, or class methods beyond above section !!
    // NO CODE AFTER THIS SECTION
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
}
